// extracted by mini-css-extract-plugin
export default {"app":"AppLayout_app__n00h+","menuFixed":"AppLayout_menuFixed__g2-n2"};